import { COLORS } from '@/styles/color';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${mediaBreakpointUp('desktop')} {
    display: grid;
    grid-template-columns: repeat(18, 1fr);

    > * {
      grid-column: 2 / -2;
    }
  }
`;

interface HeadingProps {
  color?: string;
}

export const Heading = styled.h2<HeadingProps>`
  ${customTextSize(24, 30)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  text-align: center;
  letter-spacing: -0.01em;
  margin-bottom: 40px;
  color: ${({ color }) => color ?? COLORS.BLACK};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 28)}
    margin-bottom: 60px;
  }
`;

export const List = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${mediaBreakpointUp('desktop')} {
    gap: 30px;
  }
`;

interface ListItemProps {
  accentColor?: string;
}

export const ListItem = styled.li<ListItemProps>`
  padding-left: 12px;
  border-left: 4px solid transparent;

  &[data-expanded='true'] {
    border-color: ${({ accentColor }) => accentColor ?? COLORS.BLACK};
  }
`;

export const ListItemTitle = styled.p`
  cursor: pointer;
  ${customTextSize(16, 21)}
  font-weight: var(--title-font-weight, ${FONT_WEIGHTS.SEMIBOLD});
  margin-bottom: 10px;

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(24, 34)}
    margin-bottom: 20px;
  }
`;

export const ListItemContent = styled.div`
  ${customTextSize(14, 20)}

  ${ListItem}[data-expanded="false"] & {
    display: none;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(16, 24)}
  }
`;
